export default "__VITE_ASSET__DfyZJUFp__"